// covered-by: frontends/carrie/src/components/memory-citation/__tests__/MemoryCitationChip.test.tsx

/** Marks the column a detail card keeps inside: the answer thread. */
export const POPOVER_BOUNDARY_ATTRIBUTE = "data-popover-boundary";

const SCROLLS = /^(auto|scroll|overlay)$/;

/** The nearest ancestor whose content really overflows up and down. */
export function nearestScrollParent(element: Element | null): Element | null {
  for (
    let node = element?.parentElement ?? null;
    node;
    node = node.parentElement
  ) {
    // why: a lone overflow-x: auto (the Markdown table wrapper) makes overflow-y compute to auto, and as a boundary that 113px wrapper pushed a 265px card off its chip.
    if (
      SCROLLS.test(getComputedStyle(node).overflowY) &&
      node.scrollHeight > node.clientHeight
    ) {
      return node;
    }
  }
  return null;
}

/**
 * Where the detail card must stay: for a chip in an answer, the answer column,
 * so the card does not slide over the rail beside it. A marked column counts
 * even before it has enough content to scroll, which is the usual short answer.
 * Otherwise the nearest ancestor that really scrolls, and `null`, the window,
 * when nothing does.
 */
export function popoverBoundary(element: Element | null): Element | null {
  return (
    element?.closest(`[${POPOVER_BOUNDARY_ATTRIBUTE}]`) ??
    nearestScrollParent(element)
  );
}
